import type { NPCConfig } from '@/entities';

const config: NPCConfig[] = [
  {
    x: 1900,
    y: 1520,
    name: 'Nenek',
    color: 0x9932cc,
    spriteImage: 'assets/sprite/sprite_nenek2.png',
    flipSprite : true,
    dialogTree: {
      startDialogId: 'nenek_1',
      nodes: {
        nenek_1: {
          id: 'nenek_1',
          speaker: 'Nenek',
          text: `Selamat Tinggal Yan`,
          characterImage: '/assets/character/v2/nenek.png',
          backgroundImage: '/assets/backdrop/desa.ktx2',
          nextDialogId : "nenek_2",
          isEnd: true
        },
      },
    },
  },
  {
    x: 2200,
    y: 1420,
    name: 'Elsa',
    color: 0x9932cc,
    spriteImage: 'assets/sprite/sprite_elsa.png',
    flipSprite : false,
    repeatable : true,
    dialogTree: {
      startDialogId: 'elsa_1',
      nodes: {
        elsa_1: {
          id: 'elsa_1',
          speaker: 'Elsa',
          text: `Lebih cepat lebih baik. Aku sudah tidak mau disini lagi.`,
          characterImage: '/assets/character/v2/elsa_a.png',
          backgroundImage: '/assets/backdrop/desa.ktx2',
          nextDialogId : "elsa_2",
        },
        elsa_2: {
          id: 'elsa_1',
          speaker: 'Elsa',
          text: `Ikuti Aku`,
          characterImage: '/assets/character/v2/elsa_a.png',
          backgroundImage: '/assets/backdrop/desa.ktx2',
          storyAction: { type: 'nextDay', value: 0 },
        }
      },
    },
  },
];

export default config;
